/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgClockCheck = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M4 4v2a9.984 9.984 0 0 1 8-4c5.523 0 10 4.477 10 10 0 .209-.006.416-.019.622L19.86 10.5A8.003 8.003 0 0 0 5.07 8H8v2H2V4h2zm7.19 15.96A8.001 8.001 0 0 1 4 12H2c0 5.523 4.477 10 10 10 .341 0 .678-.017 1.01-.05l-1.82-1.99z"
        fill="currentcolor"
      />
      <path
        d="M11 11V6h2v7H8v-2h3zm2.476 5.532L12 17.882l3.572 3.905 6.373-6.373L20.53 14l-4.894 4.894-2.161-2.362z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgClockCheck as ClockCheck };
